import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Benefits from './Benefits'
import Description from './Description'

import { Button, HR } from 'ui/acro'

import { unlock_membership_event } from 'gtm/pushEvents'
import { useCookies } from 'react-cookie'

const About = ({ benefits, description, planId }) => {
  const [, setCookie] = useCookies(['user_starts_plan'])

  return (
    <Fragment>
      <Button
        as='a'
        href='/subscribe'
        className='unstyled'
        id='plan_subscribe'
        onClick={() => {
          setCookie('user_starts_plan', planId, { path: '/' })
          unlock_membership_event('series')
        }}
      >
        Start my free trial
      </Button>
      <HR mt={['32px', null, '32px']} mb={['16px', null, '28px']} />
      {benefits && benefits.length > 0 && <Benefits benefits={benefits} />}
      {description && <Description description={description} />}
    </Fragment>
  )
}

About.propTypes = {
  benefits: PropTypes.array,
  description: PropTypes.string,
  planId: PropTypes.number
}

export default About
